module.exports = new __parcel__URL__("WhatsAppButtonSmall.d9efa07e.png").toString();